/**
 * mockKnowledge — KnowledgePort adapter returning canned snippets.
 *
 * Used as V0.01 default. Demonstrates how a real MCP / vector DB adapter
 * would inject organizational knowledge into LLM generation and value
 * estimation.
 */
export function createMockKnowledge() {
  const SNIPPETS = [
    {
      id: "k-1", title: "Tono comercial", category: "tone", score: 0.9,
      body: "Español LATAM formal-cercano. Nunca usar 'usted' salvo primer contacto en aseguradoras/despachos.",
    },
    {
      id: "k-2", title: "Playbook recuperación", category: "playbook", score: 0.85,
      body: "Ofrecer condición preferencial explícita cuando meses_inactivo > 9 y facturación_histórica > 20k.",
    },
    {
      id: "k-3", title: "Restricciones legales", category: "restriction", score: 0.7,
      body: "No enviar WhatsApp fuera de horario 9-19 hora local del contacto.",
    },
  ];
  return {
    async status() { return { status: "ready" }; },
    async getKnowledgeFor({ engineId, purpose }) {
      // Filter naively — a real adapter would use embeddings + retrieval
      return SNIPPETS.filter(() => purpose === "play_generation" || engineId === "recovery");
    },
  };
}
